import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { Button } from 'shared-components';
import { get } from 'shared-components/src/utils/http';
import { ProgramConfigContext } from '../../../../contexts/ProgramConfigContext';
import {
  BannerWrapper,
  BannerContent,
  IconWrapper,
  TextContent,
  Title,
  Description,
} from './styles';

const CanadaLeafIcon = () => (
  <svg width="24" height="24" viewBox="-2300 -3200 4600 5800" xmlns="http://www.w3.org/2000/svg">
    <path d="m-90 2030 45-863a95 95 0 0 0-111-98l-859 151 116-320a65 65 0 0 0-20-73l-941-762 212-99a65 65 0 0 0 34-79l-186-572 542 115a65 65 0 0 0 73-38l105-247 423 454a65 65 0 0 0 111-57l-204-1052 327 189a65 65 0 0 0 91-27l332-652 332 652a65 65 0 0 0 91 27l327-189-204 1052a65 65 0 0 0 111 57l423-454 105 247a65 65 0 0 0 73 38l542-115-186 572a65 65 0 0 0 34 79l212 99-941 762a65 65 0 0 0-20 73l116 320-859-151a95 95 0 0 0-111 98l45 863z" />
  </svg>
);

const CraDdaBanner = ({ accountId, onEnroll }) => {
  const intl = useIntl();
  const programConfig = useContext(ProgramConfigContext);
  const [hasParticipant, setHasParticipant] = useState(null);
  const [loading, setLoading] = useState(true);

  const isEnabled = programConfig && programConfig.cra_dda_enabled;

  useEffect(() => {
    if (!isEnabled || !accountId) {
      setLoading(false);
      return;
    }

    const checkParticipant = async () => {
      try {
        await get(
          `/api/v1/cardholder_portal/cardholder/accounts/${accountId}/cra-dda-participant`
        );
        // Record found - don't show banner
        setHasParticipant(true);
      } catch (e) {
        // 404 or error - no record, show banner
        setHasParticipant(false);
      }
      setLoading(false);
    };

    checkParticipant();
  }, [accountId, isEnabled]);

  // Don't render if: not enabled, still loading, or already enrolled
  if (!isEnabled || loading || hasParticipant !== false) {
    return null;
  }

  return (
    <BannerWrapper>
      <BannerContent>
        <IconWrapper>
          <CanadaLeafIcon />
        </IconWrapper>
        <TextContent>
          <Title>{intl.messages['cra-dda-banner-title']}</Title>
          <Description>{intl.messages['cra-dda-banner-description']}</Description>
        </TextContent>
      </BannerContent>
      <Button
        type="primary"
        size="large"
        onClick={onEnroll}
      >
        {intl.messages['cra-dda-enroll-button']}
      </Button>
    </BannerWrapper>
  );
};

CraDdaBanner.propTypes = {
  accountId: PropTypes.number.isRequired,
  onEnroll: PropTypes.func.isRequired,
};

export default CraDdaBanner;
